export const newsBg = require('images/news/newsBg.webp');
export const newsDetailBg = require('images/news/newsDetailBg.webp');
export const relatedPosts = require('images/news/relatedPosts.webp');
